export default __webpack_public_path__ + "static/bxg-eb0726f57430d1aa5e3572c7f4a779bd.png";